module.exports = new __parcel__URL__("Nobel-Book.fa9f6edb.woff2").toString();